import React, { Component } from 'react'
import styled from "styled-components";
import { Button, ButtonGroup, Dropdown } from 'react-bootstrap'

import axios from 'axios';

const StyledSubmitButton = styled(Button)`
  background-color: rgb(96, 93, 186);
  border-color: rgb(96, 93, 186);
  font-family: Roboto, Helvetica, Arial, sans-serif;
  font-size: 0.9375rem;
  color: #fff;
  box-sizing: border-box;
  outline-width: 0px;
  border-top-width: 0px;
  border-right-width: 0px;
  border-bottom-width: 0px;
  border-left-width: 0px;
  margin-top: 0px;  
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px -1px, rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;
  border-top-left-radius: 2em;
  border-top-right-radius: 2em;
  border-bottom-right-radius: 2em;
  border-bottom-left-radius: 2em;
  height: 56px;
`;

export default class ConnectPayroll extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPayrollProvider: "unselected",
      providers: [],
      providerFields: [],
      validationErrors: {},
      email: '',
      company: '',
      userId: '', 
      username: '',
      customerId: '',
      password: '',
      signInUrl: '',
      formValid: false,
      formSubmitted: false,
      submissionError: ''
    };
  }

  onDropdownClick(value) {
    this.setState({
      selectedPayrollProvider: value
    });
    this.loadProviderFields(this.state.providers[value]);
  }

  onSubmitClick(value) {
    if (this.validateForm(true)) {
      this.postCredentials();
    }
  }

  componentDidMount() {
    this.loadProviders();
  }

  loadProviders() {
    axios.get(`https://payroll.notchup.app:8080/v1/providers`, {
//    axios.get(`http://localhost:8080/v1/providers`, {
    }).then((res) => {
      if (res.data && res.data.responseObject) {
        let providers = {};
        for (const provider of res.data.responseObject) {
          providers[provider.name] = provider.id;
        }
        this.setState({
          providers
        });
      }
    }).catch((error) => {
      console.log("ERROR: " + JSON.stringify(error));
      this.setState({
        submissionError: `An Error Occurred while submitting payroll credentials [${error.message}]`
      });        
    });
  }

  loadProviderFields(providerId) {
    axios.get(`https://payroll.notchup.app:8080/v1/providers/${providerId}/credentialfields`, {
//    axios.get(`http://localhost:8080/v1/providers/${providerId}/credentialfields`, {
    }).then((res) => {
      if (res.data) {
        this.setState({
          providerFields: res.data.responseObject
        });
      }
    }).catch((error) => {
      console.log("ERROR: " + JSON.stringify(error));
      this.setState({
        submissionError: `An Error Occurred while submitting payroll credentials [${error.message}]`
      });        
    });    
  }

  postCredentials() {
    axios.post(`https://payroll.notchup.app:8080/v1/userCredentials`, {
//    axios.post(`http://localhost:8080/v1/userCredentials`, {
      provider_id: this.state.providers[this.state.selectedPayrollProvider],
      email: this.state.email,
      company: this.state.company,
      user_id: this.state.userId,
      username: this.state.username,
      customer_id: this.state.customerId,
      sign_in_url: this.state.signInUrl,
      password: this.state.password
    }).then((res) => {
      this.setState({
        formSubmitted: true
      });
    }).catch((error) => {
      this.setState({
        submissionError: `An Error Occurred while submitting payroll credentials [${error.message}]`
      });        
    });
  }

  updateField(event) {
    this.setState({[event.target.name]: event.target.value}, () => this.validateForm(false));
  }

  validateForm(isSubmit) {
    let validationErrors = {};

    let isFormValid = true;

    if (this.state.selectedPayrollProvider === 'unselected') {
      validationErrors.payrollProvider = 'Please select one of the available payroll platforms';
      isFormValid = false;
    }

    for (const providerField of this.state.providerFields) {
      switch (providerField.field_type) {
        case 'email_field': {
          let emailValid = this.state[providerField.field_name].match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);

          if ((((this.state.email.length > 10) && (!isSubmit)) || (isSubmit)) && 
              (!emailValid)) {
            validationErrors[providerField.field_name] = `Please enter a valid email address.`;
            isFormValid = false;
          }
        } break;
        case 'password_field': {
          if (isSubmit && (this.state[providerField.field_name].length === 0)) {
            validationErrors[providerField.field_name] = `Please enter your account's password.`;
            isFormValid = false;
          }
        } break;
        case 'string_field': {
          if (isSubmit && (this.state[providerField.field_name].length === 0)) {
            switch (providerField.field_name) {
              case 'company':
                validationErrors[providerField.field_name] = `Please enter the company name associated with your account.`;
                break;
              case 'userId':
                validationErrors[providerField.field_name] = `Please enter your account's User ID.`;
                break;
              case 'customerId':
                validationErrors[providerField.field_name] = `Please enter your account's Customer ID.`;
                break;
              case 'username':
                validationErrors[providerField.field_name] = `Please enter your account's Username.`;
                break;
              default:
                validationErrors[providerField.field_name] = `Please enter your account's ${providerField.field_name}.`;
                break;
            }
            isFormValid = false;
          }
        } break;
        case 'url_field': {
          const urlRegex = /^((http(s?)?):\/\/)?([wW]{3}\.)?[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/g;
          const signInUrlMatched = this.state[providerField.field_name].match(urlRegex);
          if (isSubmit && !signInUrlMatched) {
            validationErrors[providerField.field_name] = `Please enter your sign-in url`;
            isFormValid = false;
          }
        }
      }
    }

    this.setState({
      validationErrors
    });

    return isFormValid;
  }

  errorClass(error) {
    return((!error || (error.length)) === 0 ? '' : 'has-error');
  }

  renderPayrollProviderFields() {
    return (
      <div>
        {
          this.state.providerFields.map((providerField) => {
            return (
              <div>
                <div className="mb-3">
                  <label>{providerField.field_label}</label>
                  <input
                    type={providerField.field_type === 'email_field' ? 'email' : 
                        (providerField.field_type === 'password_field' ? 'password' : 'string')}
                    name={providerField.field_name}
                    value={this.state[providerField.field_name]}
                    onChange={(event) => this.updateField(event)}
                    className="form-control"
                    placeholder={providerField.field_placeholder}
                  />
                </div>
                <div className={
                  `form-group ${this.errorClass(this.state.validationErrors[providerField.field_name])}`
                }>{this.state.validationErrors[providerField.field_name]}</div>
              </div>
            )
          })
        }
      </div>
    );
  }

  renderPayrollProviderDropdownItems() {
    return (
      Object.keys(this.state.providers).map((providerName) => {
        return (
          <Dropdown.Item className="dropdown-item" onClick={() => this.onDropdownClick(providerName)}>{providerName}</Dropdown.Item>
        )
      })
    );
  }

  render() {
    const success = this.state.formSubmitted;

    return (
      <form>
        <div style={{ display: success ? 'none' : 'block'}}>
          <h3>Connect Your Payroll Account</h3>          
          <div className="mb-3">
            <Dropdown
              as={ButtonGroup}
              id="payroll-providers-dropdown" >
              <Button disabled={true}>{this.state.selectedPayrollProvider === "unselected" ? "Please Choose Your Payroll Provider" : this.state.selectedPayrollProvider}</Button>
              <Dropdown.Toggle split={true} id="dropdown-split-basic"> 
              </Dropdown.Toggle>
              <Dropdown.Menu>
                { this.renderPayrollProviderDropdownItems() }
              </Dropdown.Menu>
            </Dropdown>
          </div>

          { this.renderPayrollProviderFields() }

          <div className="d-grid">
            <StyledSubmitButton onClick={() => this.onSubmitClick()} className="submit-button">
              CONNECT PAYROLL ACCOUNT
            </StyledSubmitButton>
            <div className={
              `form-group ${this.errorClass(this.state.validationErrors.payrollProvider)}`
            }>{this.state.validationErrors.payrollProvider}</div>          
          </div>
        </div>

        <div className={
          `form-group ${this.errorClass(this.state.submissionError)}`
        }>
          {this.state.submissionError ? "An error occurred while submitting your information.  Our administrators have been alerted and will resolve this situation as soon as possible.  Please try again later." : ''}
        </div>

        <div style={{ display: success ? 'block' : 'none'}}>
          <h3>SUCCESS!</h3>
          <h4>
            We received your information.
          </h4>
        </div>        
      </form>
    )
  }
}
